export const FETCH_INVOICES_REQUEST = "API/ENTITIES/INVOICES/INVOICES_REQUEST";
export const FETCH_INVOICES_REQUEST_SUCCESS =
  "API/ENTITIES/INVOICES/INVOICES_REQUEST_SUCCESS";
export const FETCH_INVOICES_REQUEST_FAILURE =
  "API/ENTITIES/INVOICES/INVOICES_REQUEST_FAILURE";
